import React from 'react'

export type SplitViewIconProps = {
    style?: React.CSSProperties
}

export function SplitViewIcon({ style }: SplitViewIconProps): React.ReactElement {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            style={style}
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-table"
            version="1.1"
            id="svg4"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="SplitViewIcon"
        >
            <defs id="defs8" />
            <g id="g319" transform="translate(0,22)">
                <g id="g313">
                    <g id="g309">
                        <path
                            d="M 9,-19 H 5 c -1.1045695,0 -2,0.895431 -2,2 v 4 m 6,-6 h 10 c 1.104569,0 2,0.895431 2,2 v 4 M 9,-1 h 10 c 1.104569,0 2,-0.895431 2,-2 V -13 M 9,-1 H 5 C 3.8954305,-1 3,-1.895431 3,-3 v -10 m 0,0 h 18"
                            id="path2"
                        />
                    </g>
                </g>
                <path d="M 12,-13 V -1" id="path282" />
            </g>
        </svg>
    )
}
